import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    actions: 'Actions',
    blockThisDevice: 'Block this device',
    blockThisDeviceDescription:
      'To avoid any fraudulant activity on your account. A device can be unblocked at any time.',
    currentStatus: 'Current status',
    lastActivity: 'Last activity',
    location: 'Location',
    unblockThisDevice: 'Unblock this device',
    unblockThisDeviceDescription:
      'You will be able to connect to your Shine account with device again.',
  },
  fr: {
    actions: 'Actions',
    blockThisDevice: 'Bloquer cet appareil',
    blockThisDeviceDescription:
      'Pour éviter toute utilisation frauduleuse de votre compte. Un appareil bloqué peut être débloqué à tout moment.',
    currentStatus: 'Statut actuel',
    lastActivity: 'Dernière activité',
    location: 'Lieu',
    unblockThisDevice: 'Débloquer cet appareil',
    unblockThisDeviceDescription:
      'Vous pourrez de nouveau vous connecter à votre compte Shine sur cet appareil.',
  },
});

export default locales;
